import React from "react";
import { Check } from "lucide-react";
import { FASSADE_OPTIONS, GENERAL_CHECKLIST_OPTIONS } from "./constants";

export const ChecklistItem = ({ item, isChecked, onToggle, onSelectOption, selectedOption }) => {
  const match = item.match(/^([^(]+)(\([^)]+\))?$/);
  const mainText = match ? match[1].trim() : item;
  const parenText = match && match[2] ? match[2] : '';
  
  const isFassade = item === "Gesamtansicht der Fassade";
  const hasSpecialOption = selectedOption && typeof selectedOption === 'string';
  const generalOption = GENERAL_CHECKLIST_OPTIONS.find(opt => opt.value === selectedOption);
  
  const getStatusDisplay = () => {
    if (generalOption) {
      const colorMap = {
        gray: {
          bgColor: 'bg-gray-500',
          textColor: 'text-gray-600',
          borderColor: 'border-gray-300',
          bgLight: 'bg-gray-50'
        },
        blue: {
          bgColor: 'bg-blue-500',
          textColor: 'text-blue-600',
          borderColor: 'border-blue-300',
          bgLight: 'bg-blue-50'
        },
        green: {
          bgColor: 'bg-green-500',
          textColor: 'text-green-600',
          borderColor: 'border-green-300',
          bgLight: 'bg-green-50'
        },
        red: {
          bgColor: 'bg-red-500',
          textColor: 'text-red-600',
          borderColor: 'border-red-300',
          bgLight: 'bg-red-50'
        }
      };

      const colorConfig = colorMap[generalOption.color] || colorMap.green;

      return { 
        text: generalOption.label, 
        ...colorConfig
      };
    }
    if (hasSpecialOption && isFassade) {
      return { text: selectedOption, bgColor: 'bg-green-500', textColor: 'text-green-600', borderColor: 'border-green-300', bgLight: 'bg-green-50' };
    }
    if (isChecked) {
      return { text: 'GEPRÜFT/OK', bgColor: 'bg-green-500', textColor: 'text-green-600', borderColor: 'border-green-300', bgLight: 'bg-green-50' };
    }
    return { text: 'NACHPRÜFUNG!', bgColor: 'bg-gray-200', textColor: 'text-orange-500', borderColor: 'border-gray-200', bgLight: 'bg-white' };
  };
  
  const status = getStatusDisplay();
  const isActive = isChecked || hasSpecialOption || generalOption;

  return (
    <div className={`w-full text-left p-2 rounded border transition-all ${status.bgLight} ${status.borderColor}`}>
      <button
        onClick={onToggle}
        className="w-full flex items-start gap-2"
        data-testid={`checklist-item-${item.replace(/\s+/g, '-').toLowerCase()}`}
      >
        <div className={`mt-0.5 flex-shrink-0 w-5 h-5 rounded flex items-center justify-center ${
          isActive ? status.bgColor + ' text-white' : 'bg-gray-200'
        }`}>
          {isActive && <Check className="w-3 h-3" />}
        </div>
        <div className="flex-1 text-left">
          <span className="text-xs">
            {mainText}
            {parenText && <span className="text-[10px] text-gray-500"> {parenText}</span>}
          </span>
          <div className={`text-xs font-semibold mt-0.5 ${status.textColor}`}>
            {status.text}
          </div>
        </div>
      </button>
      
      {!isFassade && (
        <div className="mt-2 pl-7">
          <select
            value={generalOption ? selectedOption : ''}
            onChange={(e) => onSelectOption(e.target.value || false)}
            className="w-full text-xs p-1.5 border rounded bg-white"
            data-testid={`checklist-options-${item.replace(/\s+/g, '-').toLowerCase()}`}
          >
            <option value="">-- Sonderstatus (optional) --</option>
            {GENERAL_CHECKLIST_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>
        </div>
      )}
      
      {isFassade && (
        <div className="mt-2 pl-7">
          <select
            value={(!generalOption && hasSpecialOption) ? selectedOption : ''}
            onChange={(e) => onSelectOption(e.target.value || false)}
            className="w-full text-xs p-1.5 border rounded bg-white"
            data-testid="fassade-options-select"
          >
            <option value="">-- Detailauswahl (optional) --</option>
            {FASSADE_OPTIONS.map((option) => (
              <option key={option} value={option}>{option}</option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
};

export default ChecklistItem;
